import styled from "styled-components";

import { colorsPalettes, setElevation } from "@similarweb/styles";
import { Autocomplete } from "@similarweb/ui-components";

export const StyledAutocomplete = styled(Autocomplete)`
    .AutoCompleteContainer .ListItemsContainer {
        display: none !important;
    }
`;

export const PortalDropdownContainer = styled.div<{
    top: number;
    left: number;
    width: number;
}>`
    position: fixed;
    top: ${({ top }) => top}px;
    left: ${({ left }) => left}px;
    width: ${({ width }) => width}px;
    max-height: min(240px, calc(100vh - ${({ top }) => top}px - 20px));
    background: ${colorsPalettes.carbon[0]};
    border: 1px solid ${colorsPalettes.carbon[50]};
    border-radius: 3px;
    ${setElevation("Z2")};
    overflow: hidden auto;
    z-index: 10000;
`;
